(function () {
  'use strict';
  function init() {
    var banner = document.querySelector('[data-bcf-weekly-feature]');
    if (!banner || banner.dataset.offerReady === 'true') return;
    banner.dataset.offerReady = 'true';
    var link = banner.querySelector('.bcf-summer-sale__message');
    if (!link) return;
    function refreshLink() {
      var current = new URL(window.location.href);
      var params = new URLSearchParams(current.search);
      var root = document.querySelector('[data-bcf-pdp][data-bcf-family]');
      var key = root && root.dataset.bcfFamily;
      var api = window.BCFFamilyPDP;
      var family = window.BCFFamilyCatalog && window.BCFFamilyCatalog.families[key];
      var width = api && api.state ? api.state.width : params.get('width');
      var length = Number(api && api.state ? api.state.length : params.get('length'));
      var entry = family && family.widths[width];
      var variant = entry && entry.variants[length];
      var eligible = ['rope', 'curb', 'figaro'].indexOf(key) !== -1 && variant && !(key === 'rope' && width === '040');
      var subtle = params.get('040');
      if (key === 'rope' && window.BCFBundleFit) {
        var fit = window.BCFBundleFit.snapshot();
        subtle = fit.state.lengths['040'] || subtle;
      }
      if ([18, 20, 22, 24].indexOf(Number(subtle)) === -1) subtle = 18;
      // Preserve tracking; replace only product-selection query values.
      ['040', '050', '060', '070', '080', '100', '120', '150', '180', 'adjust', 'singleWidth', 'singleLength'].forEach(function (name) { params.delete(name); });
      var target;
      if (eligible) {
        target = new URL(current.pathname, current.origin);
      } else {
        target = new URL('/products/925-sterling-silver-rope-chain050-2-5mm-16-inches-30-inches', current.origin);
        key = 'rope'; width = '050'; length = 20; variant = { id: '48590439350497' };
      }
      params.set('offer', 'pair');
      params.set('width', width);
      params.set('length', String(length));
      params.set('variant', String(variant.id));
      params.set('040', String(subtle));
      if (key === 'rope') {
        params.set('singleWidth', width);
        params.set('singleLength', String(length));
        params.set(width, String(length));
      }
      target.search = params.toString();
      target.hash = 'bundle';
      link.href = target.toString();
    }
    ['pointerdown', 'focus', 'click', 'contextmenu'].forEach(function (event) { link.addEventListener(event, refreshLink); });
    var root = document.querySelector('[data-bcf-pdp][data-bcf-family]');
    if (root) ['bcf:fit-state', 'bcf:variant-change'].forEach(function (event) { root.addEventListener(event, refreshLink); });
    refreshLink();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
